import { forwardRef, Icon } from "@chakra-ui/react";
import { motion } from "framer-motion";

const WrappedIcon = forwardRef((props, ref) => (
  <span ref={ref}>
    <Icon {...props} />
  </span>
));
export const MotionIcon = motion(WrappedIcon);
